<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="loading" v-if="loading">

        </div>
        <div class="container" v-else>
          <div :class="`main-${AnswerType}`">
            <div :class="`${AnswerType}-header`">
              <h3 class="title">
                <div class="item">
                  {{ $t('cs102.title') }}
                </div>
              </h3>
            </div>
            <!-- 유형 버전(Class) : typeVersion / 유형 이벤트(Class) : typeEvent / 유형 확인중(Class) : typeChecking -->
            <div :class="[`${AnswerType}-view`,typeClass(inquire.type)]">
              <div class="header">
                <div class="type">
                  <div class="item">
                    {{ findTypeKey(inquire.type) }}
                  </div>
                </div>
                <div class="title">
                  {{ inquire.title }}
                </div>
                <div class="writer">
                  {{ inquire.user_name }} ({{ inquire.user_id }})
                </div>
                <div class="date">
                  {{ inquire.isrt_dt ? inquire.isrt_dt : '-' }}
                </div>
              </div>
              <div class="body">
                <div class="view" v-html="replaceNewLine(inquire.content)">
                </div>
                <div class="info answer">
                  <div class="caption answer">
                    <div class="title">
                      {{ $t('cs102.replyStatus') }}
                    </div>
                    <div class="content">
                      {{ isAnswered ? $t('cs102.answered') : $t('cs102.checking') }}
                    </div>
                  </div>
                  <div class="date" v-if="isAnswered">
                    {{ inquire.reply_dt ? inquire.reply_dt : '-' }}
                  </div>
                  <div class="writer" v-if="isAnswered">
                    {{ inquire.reply_name }} ({{ inquire.reply_id }})
                  </div>
                </div>
                <div class="view answer" v-if="isAnswered" v-html="replaceNewLine(inquire.reply_content)"></div>
              </div>
            </div>
            <div :class="`${AnswerType}-button`">
              <button class="list" @click="moveMenu('/CS101')">
                {{ $t('common.list') }}
              </button>
              <button class="registration" v-if="!isAnswered && userInfo.userRole !== 'ClubManager' && userInfo.userRole !== undefined" @click="moveMenu('/CS105?inquire_id=' + inquireId)">
                {{ $t('cs102.registerReply') }}
              </button>
              <button class="edit" v-else-if="userInfo.userRole !== 'ClubManager' && userInfo.userRole !== undefined" @click="moveMenu('/CS106?inquire_id=' + inquireId)">
                {{ $t('cs102.editReply') }}
              </button>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {csService, userService} from '../../router'

export default {
  name: 'CS102',
  data () {
    return {
      loading: true,
      inquireId: '',
      inquire: {}
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
  },
  mounted: function () {
    this.inquireId = this.$route.query.inquire_id
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      csService.getInquireId(this.inquireId).then(response => {
        if (response.statusCode !== 200) this.moveMenu('CS101')
        this.inquire = response.data.inquire
        if (this.isAnswered) {
          document.querySelector('body.type-content').classList.remove('id-customer-inquiry-view-ing')
          document.querySelector('body.type-content').classList.add('id-customer-inquiry-view-complete')
        }
        this.loading = false
      }).catch(error => {
        console.log('getInquireId.err ===>', error)
      })
    },
    findTypeKey (searchType) {
      if (this.searchTypeList.find(it => it.key === searchType) !== undefined) {
        return this.searchTypeList.find(it => it.key === searchType).value
      } else {
        return ''
      }
    },
    typeClass: function (type) {
      let classType = ''
      switch (type) {
        case 'service':
          classType = 'typeChecking'
          break
        case 'update':
          classType = 'typeVersion'
          break
        case 'event':
          classType = 'typeEvent'
          break
      }
      return classType
    }
  },
  computed: {
    searchTypeList: function () {
      return [
        {
          key: 'all',
          value: this.$t('common.all')
        },
        {
          key: 'service',
          value: this.$t('cs102.typeService')
        },
        {
          key: 'event',
          value: this.$t('cs102.typeEvent')
        },
        {
          key: 'update',
          value: this.$t('cs102.typeUpdate')
        }
      ]
    },
    isAnswered: function () {
      return this.inquire.status === 'completed'
    },
    AnswerType: function () {
      return this.isAnswered ? 'answer' : 'question'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cs/CS102.vue